import { Reveal, Chapter } from "./Reveal";
import { STEPS, IMAGES } from "../data/site";

export const Journey = () => (
  <section id="percorso" className="py-20 lg:py-32 bg-[#F3EFE6]" data-testid="journey-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <Chapter number="04" label="Come funziona il percorso" />
          <Reveal delay={0.08}>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight leading-[1.15] mt-5 text-[#1C1E1D] max-w-2xl">
              Quattro passi, <em className="text-[#4A6B5D] not-italic">al tuo ritmo</em>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.15}>
          <div className="overflow-hidden rounded-2xl spotlight-img">
            <img src={IMAGES.session} alt="Un momento di dialogo durante una seduta"
                 className="w-full h-64 lg:h-72 object-cover hover:scale-105 transition-transform duration-700" data-testid="journey-image" />
          </div>
        </Reveal>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={0.08 * i} className="relative">
            <div className="border-t-2 border-[#1C1E1D]/15 pt-6 relative">
              <span className="absolute -top-[5px] left-0 w-2 h-2 rounded-full bg-[#C85A32]" />
              <p className="font-mono text-xs tracking-[0.25em] text-[#C85A32]" data-testid={`step-number-${s.n}`}>{s.n}</p>
              <h3 className="font-serif text-xl font-medium text-[#1C1E1D] mt-3 leading-snug">{s.title}</h3>
              <p className="mt-3 text-sm text-[#525754] leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
